import { apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import {
  FintracSettings,
  FintracSettingsFormValues,
} from '../../reports/fintrac/types';

export const reportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFintracSettings: build.query<{ data: FintracSettings }, void>({
      query: () => ({
        url: '/v1/settings/fintrac',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateFintracReportSettings: build.mutation<
      { data: FintracSettings },
      FintracSettingsFormValues
    >({
      query: (body) => ({
        url: '/v1/settings/fintrac',
        method: 'PUT',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetFintracSettingsQuery,
  useUpdateFintracReportSettingsMutation,
} = reportsApi;

export const {
  endpoints: { getFintracSettings, updateFintracReportSettings },
} = reportsApi;
